import FilterGroupPaste from '@/views/private/realestate/components/FilterGroupPaste.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default {
  props: ['title'],
  name: 'FilterFolder',
  mixins: [ActionsForm, ExpenseMixin],
  components: {FilterGroupPaste, AutocompleteZ},
  data () {
    return {
      SearchItems: {
        corretorid: '',
        clienteId: '',
        empreendimentoId: '',
        formaPagament: '',
        DataInicio: '',
        DataFinal: '',
        corretor: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        imobiliariaObj: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      lista: [],
      dataFolders: [],
      filterByIdItens: {
        corretor: '',
        clienteId: '',
        empreendimentoId: null,
        formaPagament: '',
        DataInicio: '',
        DataFinal: ''
      }
    }
  },
  mounted () {
    this.GetAllFolder()
  },
  methods: {
    setPerson (e) {
      let disabled = document.querySelectorAll('.names-folder-active')
      disabled.forEach((Element) => {
        Element.classList.remove('names-folder-active')
        Element.classList.add('names-folder')
      })

      if (e.target.classList.contains('names-folder-active')) {
        e.target.classList.remove('names-folder-active')
        e.target.classList.add('names-folder')
      } else {
        e.target.classList.remove('names-folder')
        e.target.classList.add('names-folder-active')
      }
    },
    GetAllFolder () {
      CommissionRepository.GetIdsAndFilter()
        .then(res => {
          if (res.status === 200) {
            this.dataFolders = res.data.data
          }
        })
        .catch(err => console.log(err))
    },
    filterById (id) {
      this.$emit('updateTable', id)
    },
    GetAllCorretorsFilter (id, e) {
      this.$emit('SearchItems', id)
      this.setPerson(e)
      // CommissionRepository.GetAllCorretorsFilter(id)
      //   .then(res => {
      //     if (res.status === 200) {
      //       let newRequestsArray = res.data.data
      //       let newResponse = res
      //     }
      //   })
      //   .catch(err => console.log(err))
    },
    selectFilterParam () {
      let pasteOpen = true
      let open = this.$refs.pasteRef.filter((Element) => Element.isOpen === true)
      if (open.length === 0) {
        pasteOpen = false
      }
      if (pasteOpen === false) {
        this.$emit('getAll')
      }
    },
    Search () {
      this.SearchItems.corretor = this.SearchItems == null ? null : this.SearchItems.corretor == null ? null : this.SearchItems.corretor.value
      this.SearchItems.imobiliariaObj = this.SearchItems == null ? null : this.SearchItems.imobiliariaObj == null ? null : this.SearchItems.imobiliariaObj.value
      this.$emit('updateTable', this.SearchItems)
      localStoreHelper.consulta.vendas(this.SearchItems)
    },
    Clear () {
      localStoreHelper.consulta.vendas(null)
      this.$refs.ImobliariaTypeahead.clear()
      this.$refs.ClienteTypeahead.clear()
      this.$emit('updateTable', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/filterfolder/filterfolder.js